module.exports = __webpack_public_path__ + "img/logo_ilcovo.64857d76.svg";